import React, { useState, useEffect } from 'react';

import Button from 'b2b-ui-components-lib/lib/components/button';
import CancelOrderPopup from '../../cancelOrderPopup/cancelOrderPopup';
import EmailPopup from '../../emailPopup/emailPopup';
import { numberWithCommas } from '../../../../common/utils/app.utils';
import {
  faOnDedicatedSummaryPageCancel,
  faOnDedicatedSummaryCancelOrderPopupLoad,
  faOnDedicatedSummaryCancelOrderPopupSubmit,
  faOnDedicatedSummaryPageSubmit
} from '../../../services/analytics.service';
import { ORDER_TYPE, isAppointmentJourney } from 'common/constants/app.constants';
import { NOTIFICATION_MESSAGE } from 'home/view/manage-feasibility/constants/multiSite-constants';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';

const FooterComponent = (props) => {
  let {
    order: {
      lead: {
        connectivityLineItems: [connectivityLineItem],
        lineItemCount
      },
      ocLinkSentAtList = [],
      orderStatus
    },
    formData: { billingDetails },
    isFormValid,
    submitOrder,
    updateOrder,
    setNotification,
    fetchOrder,
    showEmailPopup,
    setShowEmailPopup = () => {},
    isOrderConfirmation,
    onSubmitClick
  } = props;
  const { planDetail = {}, email } = connectivityLineItem;
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [viewMore, setViewMore] = useState(false);
  const ocLinkSentAt = ocLinkSentAtList?.join(', ').toString();

  const isShiftingOrder = () => {
    return props?.order?.orderType === 'CHANGE_ORDER' && props?.order?.orderSubType === 'SHIFTING';
  };

  const onCancel = () => {
    setShowCancelPopup(true);
    faOnDedicatedSummaryPageCancel();
  };

  const isOrderConfirmationPending = () => {
    return orderStatus === ORDER_TYPE.ORDER_CONFIRMATION_PENDING;
  };

  const onSubmit = () => {
    const params = {
      ...planDetail,
      billingType: billingDetails && billingDetails.type && billingDetails.type.id
    };
    faOnDedicatedSummaryPageSubmit(params);
    if (isAppointmentJourney()) {
      onSubmitClick?.();
    } else if (isOrderConfirmationPending()) {
      fetchOrder(setShowEmailPopup);
    } else {
      updateOrder().then(
        (resp) => {
          setShowEmailPopup(true);
        },
        (err) => {
          console.error(err);
        }
      );
    }
  };

  const onViewMoreLessClick = () => {
    setViewMore(!viewMore);
  };

  const setOTPVerification = (verified) => {
    if (verified) {
      submitOrder();
    }
  };

  const getServiceType = () => {
    let serviceType = 'Standard IP';
    if (Array.isArray(planDetail.specs)) {
      const standardKey = ['ipType', 'lanIPSubnet', 'lanIP6Subnet', 'ip6Type'];
      planDetail.specs.forEach((spec) => {
        if (standardKey.includes(spec.name) && spec.commercial === true) {
          serviceType = 'Non-Standard IP';
        }
      });
    }
    return serviceType;
  };

  const showNotificationForSentEmail = (orderStatus) => {
    if (orderStatus === ORDER_TYPE.ORDER_CONFIRMATION_PENDING) {
      const EmailSentmessage = (
        <p>
          Order confirmation link has been sent to <a href="javascript:void(0)"> {ocLinkSentAt}</a> to {NOTIFICATION_MESSAGE.CONFIRM_ORDER}
        </p>
      );
      const verifierMessage = <p>To verify the order click on {NOTIFICATION_MESSAGE.CONFIRM_ORDER}</p>;
      setNotification((prevState) => {
        return { ...prevState, show: true, message: isOrderConfirmation && isOrderConfirmationUrl() ? verifierMessage : EmailSentmessage };
      });
    }
  };

  useEffect(() => {
    showNotificationForSentEmail(orderStatus);
  }, [orderStatus]);

  useEffect(() => {
    document.getElementById('root').className = 'pricing-strip';
    return () => {
      document.getElementById('root').classList.remove('pricing-strip');
    };
  }, []);

  return (
    <React.Fragment>
      <div className={`selected-plans active`}>
        {/* add class "full_plans" to show pull plan items */}
        <div className="container">
          <div className={`inside-plan ${viewMore ? 'show_full_view' : ''}`}>
            <div className="plan-info">
              <div className="plan_details_veiw">
                <div className="left_col">
                  <h4>Total Amount</h4>
                  <div class="value mt-10">
                    &#8377; {planDetail ? numberWithCommas(planDetail.price.amount * (planDetail.planPeriod / 12) + planDetail.price.otc) : '-'}{' '}
                    <span className="gst_charges">+GST Taxes</span>
                  </div>
                </div>
                <div className="right_col">
                  <div className="view_type" onClick={onViewMoreLessClick}>
                    {viewMore ? 'View Less' : 'View More'} <span className={`animatedarrow ${viewMore ? 'arrow_up' : ''} `}></span>
                  </div>
                </div>
              </div>
              {/* <div className="condition_info">*Additional charges may apply along with taxes.</div> */}
              {/* <div className="viewdetail">View Details</div>
            <div className="close_icon">
              <span></span>
              <span></span>
              <span></span>
            </div> */}
            </div>
            <div className="plan-details">
              <div className="item_list">
                <div className="items">
                  <div className="label">SITES IN ORDER</div>
                  <div className="value">
                    <strong>{lineItemCount}</strong>{' '}
                  </div>
                </div>
                {/* <div className="items tital_for_mobile">
                  <div className="label">Selected Plan</div>
                  <div className="value">
                    <strong>1 </strong>{' '}
                  </div>
                </div>
                <div className="items border-bottom">
                  <div className="label">Selected Bandwidth</div>
                  <div className="value">
                    <strong>{planDetail && planDetail.speed ? planDetail.speed : '-'} </strong>
                    <small>Mbps</small>
                  </div>
                </div>
                <div className="items">
                  <div className="label">Plan Details</div>
                  <div className="value" style={{ 'text-transform': 'capitalize' }}>
                    <strong>{planDetail.service ? `${planDetail.service.split('_').join(' ')} Service, ${getServiceType(planDetail)}` : '-'}</strong>
                  </div>
                </div>
                <div className="items">
                  <div className="label">Contract Period</div>
                  <div className="value">
                    <strong> {planDetail.planPeriod / 12} Year </strong>
                  </div>
                </div> */}
              </div>
              <div className="action">
                <Button variant="outlinebtn" onClick={onCancel}>
                  Cancel
                </Button>
                <Button className="activebtn" disabled={isShiftingOrder() ? false : !isFormValid} onClick={onSubmit}>
                  {isAppointmentJourney() ? 'Proceed' : 'Confirm Order'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showCancelPopup && (
        <CancelOrderPopup
          onLoad={faOnDedicatedSummaryCancelOrderPopupLoad}
          onSubmit={(data) => faOnDedicatedSummaryCancelOrderPopupSubmit(data)}
          setshowPopup={setShowCancelPopup}
          isSummaryPage={true}
          metaData={props?.order}
        ></CancelOrderPopup>
      )}

      {showEmailPopup && (
        <EmailPopup
          setNotification={setNotification}
          customer={props.order && props.order.lead && props.order.lead.customer}
          setshowPopup={setShowEmailPopup}
          email={ocLinkSentAt}
          setOTPVerification={setOTPVerification}
          orderStatus={orderStatus}
          fetchOrder={fetchOrder}
          isOrderConfirmation={isOrderConfirmation && isOrderConfirmationUrl()}
        ></EmailPopup>
      )}
    </React.Fragment>
  );
};

export default FooterComponent;
